// deps
import React, { ReactElement, useCallback, memo } from "react";

// Components
import VerifyOtp from "./components/VerifyOtp";
import Header from "./components/Header";
import { SuccessBsWithRedirect } from "@payment-ui/widgets/success-bs-redirect";

// interfaces
import { OtpVerifyActions } from "@payment-ui/interfaces";

// helpers
import { getLinkAccountTitleV4 } from "@payment-ui/helpers/LinkAccount";

// test-ids
import { LINK_ACCOUNT_VIEW_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { format } from "@swiggy-private/core-ui";

import { TEXTS } from "@payment-ui/constants/LinkAccount";

import styles from "./LinkAccountView.v4.scss";

export interface LinkAccountViewProps {
    actions: OtpVerifyActions;
    mobile: string;
    showSuccessBS?: boolean;
    onCloseBS?: VoidFunction;
    iconUrl: string;
    walletCode: string;
    displayName: string;
    verifyCtaText?: string;
}

function LinkAccountView(props: LinkAccountViewProps): ReactElement {
    const { displayName, walletCode, iconUrl, onCloseBS, showSuccessBS, mobile, verifyCtaText } = props;

    const getTitle = useCallback((): string => {
        return getLinkAccountTitleV4();
    }, []);

    const onCloseBottomSheet = useCallback(() => {
        if (typeof onCloseBS === "function") {
            onCloseBS();
        }
    }, [onCloseBS]);

    const successBSTitle = format(TEXTS.LAZYPAY_LINKED_TEXT, displayName);

    const successBSSubTitle = format(TEXTS.ALL_METHODS_USABLE, displayName);

    return (
        <>
            <div data-testid={LINK_ACCOUNT_VIEW_TEST_IDS.CONTAINER} className={styles.container}>
                <Header title={getTitle()} mobile={mobile} iconUrl={iconUrl} />
                <VerifyOtp actions={props.actions} walletCode={walletCode} ctaText={verifyCtaText} />
            </div>
            {showSuccessBS && (
                <SuccessBsWithRedirect
                    onClose={onCloseBottomSheet}
                    title={successBSTitle}
                    subTitle={successBSSubTitle}
                    durationInSec={3}
                />
            )}
        </>
    );
}

export default memo(LinkAccountView);
